import { useState, useEffect } from 'react';
import { variablesTema, cargarFuente } from '../tema';
import { useParams } from 'react-router-dom';
import TicketQR from '../components/TicketQR';
import { fmtDate, fullName } from '../events/util';

const API = process.env.REACT_APP_API_URL || '';

export default function TicketView() {
  const { code } = useParams();
  const [t, setT] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${API}/api/public/ticket/${code}`)
      .then(r => r.ok ? r.json() : Promise.reject(r))
      .then(d => { setT(d); cargarFuente(d && d.tipografia); })
      .catch(() => setError('Entrada no encontrada.'));
  }, [code]);

  return (
    <div style={{ ...variablesTema(t), minHeight: '100vh', background: 'var(--bg)', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 20px' }}>
      {t?.logo_url
        ? <img src={t.logo_url} alt={t.org_name || ''} style={{ height: 42, marginBottom: 24, objectFit: 'contain' }} />
        : <div style={{ marginBottom: 24, fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 20, color: '#fff', textTransform: 'uppercase' }}>{t?.org_name || ''}</div>}
      {error && <div style={{ color: 'var(--red-300)' }}>{error}</div>}
      {!error && !t && <div style={{ color: 'var(--ink-600)' }}>Cargando…</div>}
      {t && (
        <div style={{ width: '100%', maxWidth: 420, textAlign: 'center' }}>
          <div className="lb-display" style={{ fontSize: 24 }}>{t.event_name}</div>
          <div style={{ color: 'var(--ink-700)', fontSize: 13, marginTop: 4, textTransform: 'capitalize' }}>{fmtDate(t.date)}</div>
          <div style={{ color: 'var(--ink-700)', fontSize: 13, marginTop: 2 }}>{fullName(t.buyer_name, t.buyer_lastname)} · {t.lot_name}</div>
          {t.status === 'usado' && <div className="lb-status lb-status--used" style={{ marginTop: 12 }}>Ya utilizada</div>}
          <div style={{ marginTop: 24 }}>
            <TicketQR value={t.qr_code} transportValue={t.transport_qr || null} logo={t.logo_url} eventName={t.event_name} date={t.date} lotName={t.lot_name} attendeeName={fullName(t.buyer_name, t.buyer_lastname)} filename={`${t.event_name}-${t.qr_code}.png`} />
            {t.transport_qr && <div style={{ fontSize: 11, color: 'var(--ink-600)', marginTop: 12 }}>Una tarjeta con los dos QR: INGRESO (puerta) y TRASLADO. Cada uno, un solo uso.</div>}
          </div>
          <div style={{ textAlign: 'center', marginTop: 24, fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--ink-600)' }}>
            Acceso reservado · Dress code estricto · +18
          </div>
        </div>
      )}
    </div>
  );
}
